import moment from "moment";
import {
  formatDate,
  CurrencyFormat,
  capitalize,
} from "../../../../../components/helpers";

export const convertTransactionDetail = (transaction) => {
  // console.log("transaction", transaction);
  return {
    voucher: `Rp ${CurrencyFormat(transaction?.discount_voucher)}`,
    dateTime: formatDate(transaction.date_time),
    transactionID: transaction.transaction_id || "-",
    gadaiID: transaction.gadai_id || "-",
    gadaiCode: transaction.gadai_proof || "-",
    receiptNumber: transaction.receipt_number || "-",
    customerName: transaction.customer_name || "-",
    officerName: transaction.office_name || "-",
    customerBankName: transaction.customer_bank_name || "-",
    customerAccountNumber: transaction.customer_account_number || "-",
    customerAccountName: transaction.customer_account_name || "-",
    returnType: transaction.return_type || "-",
    description: transaction.description || "-",
    returnTotal: `Rp ${CurrencyFormat(transaction.return_total) || 0} `,
    loanAmount: `Rp ${CurrencyFormat(transaction.loan_amount) || 0} `,
    lateFine: `Rp ${CurrencyFormat(transaction.late_fine) || 0} `,
    lateStorageFee: `Rp ${CurrencyFormat(transaction.late_storage_fee) || 0} `,
    totalPayment: `Rp ${CurrencyFormat(transaction.total_payment) || 0} `,
    valuationValue: `Rp ${CurrencyFormat(transaction.valuation_value) || 0} `,
    loanCapital: `Rp ${CurrencyFormat(transaction.loan_capital) || 0} `,
    adminFee: `Rp ${CurrencyFormat(transaction.admin_fee) || 0} `,
    storeAndInsuranceFee: `Rp ${CurrencyFormat(transaction.store_and_insurance_fee)} ${transaction.store_and_insurance_fee >= 0 ? `(Rp ${CurrencyFormat(transaction?.fee_saving_assurance_sharing_assurance)} | Rp ${CurrencyFormat(transaction.fee_saving_assurance_sharing_saving)} )` : ''} ` || 0,
    transferFee: `Rp ${CurrencyFormat(transaction.transfer_fee) || 0} `,
    revaluationValueFee: `Rp ${CurrencyFormat(transaction.revaluation_value_fee) || 0
      } `,
    amountReceived: `Rp ${CurrencyFormat(transaction.amount_received) || 0} `,
    revaluationValueFee: `Rp ${CurrencyFormat(transaction.revaluation_value_fee) || 0
      } `,
    auctionServiceFee: `Rp ${CurrencyFormat(transaction.auction_service_fee) || 0
      } `,
    auctionRemaining: `Rp ${CurrencyFormat(transaction.auction_remaining) || 0
      } `,
    transactionType: transaction.transaction_type || "-",
    paymentMethod: transaction.payment_method || "-",
    offerName: transaction.offer_name || "-",
    auctionFee: `Rp ${CurrencyFormat(transaction.auction_fee) || "-"} `,
    auctionPrice: `Rp ${CurrencyFormat(transaction.auction_price) || "-"} `,
    auctionDescription: transaction.auction_description || "-",
    auctionOtherFee: `Rp ${CurrencyFormat(transaction.auction_other_fee) || "-"
      } `,
    totalFine: `Rp ${CurrencyFormat(transaction.late_fine + transaction.late_storage_fee) || 0
      } `,
    itemValue: `Rp ${CurrencyFormat(transaction.auction_price - transaction.total_payment) || 0
      } `,
    offerInterestExpenseType: transaction?.gadai_promo_loan?.promo_loan?.interest_expense_type,
    offer: transaction?.gadai_promo_loan
      ? {
        name: transaction?.gadai_promo_loan.name,
        gadaiType:
          transaction?.gadai_promo_loan.gadai_type === "pick_up"
            ? "Jemput Gadai"
            : "Reguler",
        category:
          transaction?.gadai_promo_loan?.promo_loan?.promo_loan_products
            .map((e) => {
              return e.product_category.name;
            })
            .join(", "),
        outlet:
          transaction?.gadai_promo_loan?.gadai_type !== "pick_up"
            ? transaction?.gadai_promo_loan?.promo_loan?.promo_loan_outlets
              .map((e) => {
                return e.outlet.name;
              })
              .join(", ")
            : "-",
        tenorType: capitalize(transaction?.gadai_promo_loan.tenor_type),
        paymentType:
          transaction?.gadai_promo_loan.payment_type === "balloon_payment"
            ? "Ballon Payment"
            : "Installment",
        tenor: transaction?.gadai_promo_loan?.promo_loan?.promo_loan_tenors
          .map((e) => {
            return `${e.days} Hari`;
          })
          .join(", "),
        minLoan:
          transaction?.gadai_promo_loan.min_loan_rupiah != 0
            ? "Rp " + transaction?.gadai_promo_loan.min_loan_rupiah
            : transaction?.gadai_promo_loan.min_loan_percentage + "%",
        maxLoan:
          transaction?.gadai_promo_loan.max_loan_rupiah != 0
            ? "Rp " + transaction?.gadai_promo_loan.max_loan_rupiah
            : transaction?.gadai_promo_loan.max_loan_percentage + "%",
        capitalLoan:
          transaction?.gadai_promo_loan.capital_loan_rupiah != 0
            ? "Rp " + transaction?.gadai_promo_loan.capital_loan_rupiah
            : transaction?.gadai_promo_loan.capital_loan_percentage + "%",
        feeAdmin:
          transaction?.gadai_promo_loan.fee_admin_rupiah != 0
            ? "Rp " + transaction?.gadai_promo_loan.fee_admin_rupiah
            : transaction?.gadai_promo_loan.fee_admin_percentage + "%",
        feeSavingInsurance:
          transaction?.gadai_promo_loan.fee_saving_assurance_rupiah != 0
            ? "Rp " +
            transaction?.gadai_promo_loan.fee_saving_assurance_rupiah
            : transaction?.gadai_promo_loan.fee_saving_assurance_percentage +
            "%",
        feeLateCharge:
          transaction?.gadai_promo_loan.late_charge_rupiah != 0
            ? "Rp " + transaction?.gadai_promo_loan.late_charge_rupiah
            : transaction?.gadai_promo_loan.late_charge_percentage + "%",
        feeLatePeriod:
          transaction?.gadai_promo_loan.late_charge_period_rupiah != 0
            ? "Rp " + transaction?.gadai_promo_loan.late_charge_period_rupiah
            : transaction?.gadai_promo_loan.late_charge_period_percentage + "%",
        feeLateStorage:
          transaction?.gadai_promo_loan.fee_storage_rupiah != 0
            ? "Rp " + transaction?.gadai_promo_loan.fee_storage_rupiah
            : transaction?.gadai_promo_loan.fee_storage_percentage + "%",
        feeAuction:
          transaction?.gadai_promo_loan.fee_auction_rupiah != 0
            ? "Rp " + transaction?.gadai_promo_loan.fee_auction_rupiah
            : transaction?.gadai_promo_loan.fee_auction_percentage + "%",
        maxExtend: transaction?.gadai_promo_loan.max_extension + " Hari",
        maxLate: transaction?.gadai_promo_loan.max_late + " Hari",
        gracePeriod: transaction?.gadai_promo_loan.grace_period + " Hari",
        type: "loan",
        period: `${transaction?.tenor_period || 0} Kali`,
        tenorPerPeriod: `${transaction?.tenor_days || 0} Hari`
      }
      : transaction?.gadai_extension.promo_extension
        ? {
          name: transaction?.gadai_extension?.promo_extension.name,
          gadaiType:
            transaction?.gadai_extension?.promo_extension.gadai_type ===
              "pick_up"
              ? "Jemput Gadai"
              : "Reguler",
          category:
            transaction?.gadai_extension?.promo_extension?.promo_extension_products
              .map((e) => {
                return e.product_category.name;
              })
              .join(", "),
          outlet:
            transaction?.gadai_extension?.promo_extension?.gadai_type !==
              "pick_up"
              ? transaction?.gadai_extension?.promo_extension?.promo_extension_outlets
                .map((e) => {
                  return e.outlet.name;
                })
                .join(", ")
              : "-",
          tenorType: capitalize(
            transaction?.gadai_extension?.promo_extension.tenor_type
          ),
          paymentType:
            transaction?.gadai_extension?.promo_extension.payment_type ===
              "balloon_payment"
              ? "Balloon Payment"
              : "Reguler",
          minLoan:
            "Rp " +
            transaction?.gadai_extension?.promo_extension.min_loan_rupiah,
          maxLoan:
            "Rp " +
            transaction?.gadai_extension?.promo_extension.max_loan_rupiah,
          tenor:
            transaction?.gadai_extension?.promo_extension?.promo_extension_tenors
              .map((e) => {
                return `${e.days} Hari`;
              })
              .join(", "),
          capitalLoan:
            transaction?.gadai_extension?.promo_extension.capital_loan_rupiah !=
              0
              ? "Rp " +
              transaction?.gadai_extension?.promo_extension
                .capital_loan_rupiah
              : transaction?.gadai_extension?.promo_extension
                .capital_loan_percentage + "%",
          feeAdmin:
            transaction?.gadai_extension?.promo_extension.fee_admin_rupiah != 0
              ? "Rp " +
              transaction?.gadai_extension?.promo_extension.fee_admin_rupiah
              : transaction?.gadai_extension?.promo_extension
                .fee_admin_percentage + "%",
          feeSavingInsurance:
            transaction?.gadai_extension?.promo_extension
              .fee_saving_assurance_rupiah != 0
              ? "Rp " +
              transaction?.gadai_extension?.promo_extension
                .fee_saving_assurance_rupiah
              : transaction?.gadai_extension?.promo_extension
                .fee_saving_assurance_percentage + "%",
          revaluation:
            transaction?.gadai_extension.promo_extension?.revaluation_rupiah !=
              0
              ? "Rp " +
              transaction?.gadai_extension.promo_extension?.revaluation_rupiah
              : transaction?.gadai_extension?.promo_extension
                .revaluation_percentage + "%",
          isAllowChangeValuation: transaction?.promo_extension
            ?.is_able_input_revaluation
            ? "Iya"
            : "Tidak",
          gracePeriod:
            transaction?.gadai_extension.promo_extension?.grace_period +
            " Hari",
          type: "extension",
        }
        : null,
    transactionInstallment: transactionInstallments(transaction.transaction_installment),
  };
};

const transactionInstallments = (installment) => {
  let converted = []
  installment.map(item => {
    let data = {
      periodNumber: item.gadai_installment.period_number,
      period: `${moment(item.gadai_installment.begin_date).format('DD/MM/YYYY')} - ${moment(item.gadai_installment.due_date).format('DD/MM/YYYY')} `,
      receipt: item.receipt_code,
      installmentAmount: `Rp ${CurrencyFormat(item.installment_amount) || 0} `,
      lateDays: `Rp ${CurrencyFormat(item.fee_late_charge_days) || 0} `,
      latePeriod: `Rp ${CurrencyFormat(item.fee_late_charge_period) || 0} `,
      loanCapital: `Rp ${CurrencyFormat(item.loan_capital) || 0} `,
      feeSavingInsurance: `Rp ${CurrencyFormat(item.store_and_insurance_fee) || 0} `,
      feeAdmin: `Rp ${CurrencyFormat(item.admin_fee) || 0} `,
      total: `Rp ${CurrencyFormat(item.installment_amount + item.fee_late_charge_days + item.fee_late_charge_period + item.loan_capital + item.store_and_insurance_fee + item.admin_fee) || 0} `
    }
    converted.push(data)
  })
  return converted
}